import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { push } from "connected-react-router";

import { injectIntl, intlShape } from "react-intl";
import { Checkbox } from "@material-ui/core";
import { filter } from "ramda";
import removeIcon from "../../../assets/img/shredder.svg";
import generateAction from "../../../utils/action-helpers";
import { PENDING, CLIENT, DETAIL } from "../../../state/actions";
import Table from "../../ui/table";
import Loader from "../../ui/loader";
import BigComment from "../../ui/big-comment";
import {
  toFormattedNumber,
  toHibridSocietyFormat,
  toHibridDivisionFormat,
  toFormattedDate
} from "../../../utils/format";
import PendingActions from "./pending-actions";
import TooltipButton from "../../ui/tooltip-button";
import Disclaimer from "../../ui/disclaimer";
import { calculateCurency } from "../reconciliation-detail";

const Pending = ({ intl }) => {
  const { messages } = intl;
  const { loading, error, pending, filters, pageIndex, sort, desc } = useSelector(
    state => state.pending
  );
  const dispatch = useDispatch();
  const [localPending, setLocalPending] = useState(
    pending ? pending.map(x => ({ ...x, selected: false })) : []
  );
  const [visibleDeleteAll, setVisibleDeleteAll] = useState(false);
  const setFilters = newFilters => dispatch(generateAction(PENDING.SET_FILTER, newFilters));
  const setPageIndex = newPageIndex =>
    dispatch(generateAction(PENDING.SET_PAGE_INDEX, newPageIndex));
  const setSortColumn = newColumn => dispatch(generateAction(PENDING.SET_SORT_COLUMN, newColumn));
  const setSortDesc = newDescSort => dispatch(generateAction(PENDING.SET_SORT_DESC, newDescSort));
  const handleSelectionChange = (item, newValue) => {
    setLocalPending(
      localPending.map(x => ({
        ...x,
        selected:
          x.nif === item.nif && x.name === item.name && x.amount === item.amount
            ? newValue
            : x.selected
      }))
    );
  };
  const handleDeleteAll = () => {
    dispatch(generateAction(PENDING.DELETE_TRANSFER_ALL, localPending.filter(x => x.selected)));
  };
  useEffect(() => {
    if (!pending && !loading && !error) {
      dispatch(generateAction(PENDING.FETCH));
    }
  }, [loading, error, pending, dispatch]);
  useEffect(() => {
    setLocalPending(pending ? pending.map(x => ({ ...x, selected: false })) : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLocalPending(pending ? pending.map(x => ({ ...x, selected: false })) : []);
  }, [pending]);

  if (loading) return <Loader />;
  const columns = [
    {
      name: "selected",
      label: " ",
      options: {
        filter: false,
        cellRenderer: value => {
          const { original } = value.row;
          return (
            <Checkbox
              edge="start"
              className="input-check"
              checked={original.selected}
              onChange={() => handleSelectionChange(original, !original.selected)}
            />
          );
        }
      }
    },
    {
      name: "name",
      label: messages.name,
      options: {
        filter: false,
        weigth: 2,
        sort: true,
        cellRenderer: value => <BigComment comment={value.row.original.name} maxLength={75} />
      }
    },
    {
      name: "nif",
      label: messages.nif,
      options: {
        filter: false,
        sort: true,
        weigth: 2,
        show: true
      }
    },
    {
      name: "date",
      label: messages.date,
      options: {
        filter: true,
        type: "date",
        sort: true,
        weigth: 2,
        show: true,
        cellClass: "no-wrap",
        cellRenderer: value => toFormattedDate(value.row.original.date),
        filterRenderer: value => `${value.startDate} - ${value.endDate}`
      }
    },
    {
      name: "concept",
      label: messages.concept,
      options: {
        filter: false,
        sort: true,
        weigth: 2,
        show: true,
        cellClass: "concept",
        cellRenderer: value => <BigComment comment={value.row.original.concept} maxLength={107} />
      }
    },
    {
      name: "amount",
      label: messages.amount,
      options: {
        type: "number",
        filter: false,
        sort: true,
        weigth: 2,
        show: true,
        cellRenderer: value => {
          const { amount, currency } = value.row.original;
          const currencyText = currency ? calculateCurency(currency) : "€";
          return (
            <div className="text-right mr-2">{`${toFormattedNumber(amount)}${currencyText}`}</div>
          );
        },
        filterRenderer: value => toFormattedNumber(value)
      }
    },
    {
      name: "society",
      label: messages.society,
      options: {
        filter: true,
        show: false,
        weigth: 4,
        cellRenderer: value => toHibridSocietyFormat(value.row.original.society),
        filterRenderer: value => toHibridSocietyFormat(value)
      }
    },
    {
      name: "division",
      label: messages.division,
      options: {
        filter: true,
        show: false,
        weigth: 4,
        cellRenderer: value => toHibridDivisionFormat(value.row.original.division),
        filterRenderer: value => toHibridDivisionFormat(value)
      }
    },
    {
      name: "accountNumber",
      label: messages.account,
      options: {
        filter: true,
        show: false,
        weigth: 2
      }
    },
    {
      label: messages.empty,
      options: {
        sort: false,
        filter: false,
        cellClass: "short-column",
        cellRenderer: data => {
          const { kukey, record } = data.row.original;
          return (
            <PendingActions
              onViewDetailClick={() => {
                dispatch(generateAction(CLIENT.CLEAR, { kukey, record }));
                dispatch(generateAction(DETAIL.SEARCH_TRANSFER_SUCCESS, data.row.original));
                dispatch(push(`/reconciliation-detail/${kukey}/${record}`));
              }}
              onDeleteClick={() => {
                dispatch(generateAction(PENDING.DELETE_TRANSFER, { kukey, record }));
              }}
            />
          );
        }
      }
    },
    {
      name: "bussinesLine",
      label: messages.businessLine,
      options: {
        filter: false,
        show: false,
        weigth: 4
      }
    }
  ];
  const selected = localPending.filter(x => x.selected).length;
  const tableOptions = {
    emptyElement: <span>No hay elementos conciliados en el día de hoy</span>,
    emptyFilteredElement: (
      <span>No hay resultados que coincidan con los filtros de tu búsqueda</span>
    ),
    remoteSelectedFilters: filters,
    setRemoteSelectedFilters: setFilters,
    remotePageIndex: pageIndex,
    setRemotePageIndex: setPageIndex,
    remoteSort: sort,
    setRemoteSort: setSortColumn,
    remoteDesc: desc,
    setRemoteDesc: setSortDesc,
    selectableRows: true,
    extraToolbarOptions: (
      <TooltipButton
        buttonClassName="btn-tool-table"
        onClick={() => setVisibleDeleteAll(true)}
        iconClassName="icono-trash"
        tooltipText="Eliminar transferencias seleccionadas"
        buttonText={
          selected > 0 && (
            <div className="delete-circle">
              <div className="delete-number">{selected}</div>
            </div>
        )}
      />
    )
  };

  return (
    <>
      <Table
        placeHolder="Buscar por ordenante, importe..."
        fileName="Pendientes.csv"
        className="pending"
        columns={columns}
        data={localPending || []}
        loading={loading}
        options={tableOptions}
        onFilterChange={() => setLocalPending(localPending.map(x => ({ ...x, selected: false })))}
        onSelectAllChange={(value, filtered) => {
          setLocalPending(
            localPending.map(x => ({
              ...x,
              selected: filtered.some(y => y.kukey === x.kukey && y.record === x.record)
                ? value
                : false
            }))
          );
        }}
      />
      <Disclaimer
        icon={<img src={removeIcon} alt="Eliminar partida" />}
        title="Eliminar transferencias seleccionadas"
        text="¿Desea eliminar las transferencias seleccionadas?. Esta acción no se puede deshacer."
        visible={visibleDeleteAll}
        acepptButtonText="Eliminar"
        cancelButtonText="Cancelar"
        onCancel={() => setVisibleDeleteAll(false)}
        onAccept={() => {
          setVisibleDeleteAll(false);
          handleDeleteAll();
        }}
      />
    </>
  );
};

Pending.propTypes = {
  intl: intlShape.isRequired
};

export default injectIntl(Pending);
